<template>
  <div>
      <el-dialog title="Table Title Setting" :width="dialogWidth" :visible="visible" :close-on-click-modal="false" @close="visible = false">
        <el-card style="max-height: 400px;overflow: auto;">
          <el-button style="margin-bottom: 15px;font-size: 12px;" type="text" @click="select_all_clos">
              Select All
          </el-button>
          <el-card :bodyStyle="{padding: '10px'}" style="margin-bottom: 5px;" v-for="(item, index) in tableHead_data" :key="index">
            <div style="display: flex;justify-content: space-between;align-items: center;">
              <el-checkbox v-model="item.isNeed">
                  {{item.name}}
              </el-checkbox>
              <div>
                <!-- <a-icon type="menu" style="cursor: move;"/> -->
              </div>
            </div>
          </el-card>

        </el-card>

        <div style="display: flex;justify-content: center;align-items: center;margin-top:20px;">
            <el-button type="primary" @click="save" icon="save">Save</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
  import {getActionApi,putActionApi} from '@/network/manageApi';
  import tableHeadData from '@/json/tableHeadData'
  import Vue from 'vue'

  export default {
    name: "tableTitleSetting",
    components: {
    },
    data() {
      return {
        dialogWidth:'450px',
        title: "Title Setting",
        visible: false,
        tableHead_data: [],
        selected_columns: []
      }
    },
    mounted() {
      window.onresize = () => {
        return (() => {
          this.setDialogWidth()
        })()
      }
    },
    created() {
      this.setDialogWidth()
    },
    methods: {
      select_all_clos() {
        for(let item of this.tableHead_data) {
            item.isNeed = true
        }
      },
      handleCancel() {
        this.visible = false;
      },
      init() {
        this.visible = true
        this.tableHead_data = JSON.parse(JSON.stringify(tableHeadData))
        getActionApi("/inquiry/call-inquiry/columns").then((res) => {
          this.selected_columns = res.data.selected_columns
          for(let item of this.tableHead_data) {
            if(this.selected_columns.includes(item.value)) {
              item.isNeed = true
            }
          }
        })
      },
      save() {
        let array = []
        for(let item of this.tableHead_data) {
          if(item.isNeed) {
            array.push(item.value)
          }
        }
        if(array.length == 0) {
          this.$message.error("Please select the column names to display!")
          return;
        }
        putActionApi("/inquiry/call-inquiry/columns", {"column_lists": array}).then((res) => {
          if(res.code == 200) {
            this.visible = false
            this.$emit('ok')
            this.$message.success("Setting success！")
          }
        })
      },
      setDialogWidth() {
        var val = document.body.clientWidth
        const def = 450 // default width
        if (val < def) {
          this.dialogWidth = '100%'
        } else {
          this.dialogWidth = def + 'px'
        }
      }
    }
  }
</script>
<style lang="less" scoped>

</style>
